export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const dataUrl = reader.result
      resolve(dataUrl as string)
    }
    reader.onerror = error => {
      reject(error)
    }
    reader.readAsDataURL(blob)
  })
}
